// extracted by mini-css-extract-plugin
export var button = "_cg-0";
export var donut = "_cg-1";
export var donutFill = "_cg-3";
export var donutTrack = "_cg-2";